module.exports = __webpack_public_path__ + "static/img/products_04.29b1eece.png";